export default __webpack_public_path__ + "static/media/what-will-students-see.77351116.mp4";